'use client';

import React, { useEffect, useState } from 'react';
// PHASE-11 START
import Image from 'next/image';
import { getImagePlaceholder } from '@/lib/image-placeholder';
// PHASE-11 END
import { isPWA } from '@/lib/pwa-utils';

/**
 * Splash screen component shown when the PWA first loads
 * Only displayed when running as an installed PWA
 */
const SplashScreen: React.FC = () => {
  const [show, setShow] = useState(false);
  
  useEffect(() => {
    // Only show splash screen in PWA mode
    const shouldShow = isPWA();
    setShow(shouldShow);
    
    if (shouldShow) {
      // Hide splash screen after a short delay
      const timer = setTimeout(() => {
        setShow(false);
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, []);
  
  if (!show) return null;
  
  return (
    <div id="splash-screen" className={`${show ? '' : 'hidden'} liquid-glass-splash`}>
      <div className="liquid-glass-content">
        <div className="logo-container liquid-glass rounded-3xl p-6 border border-white/10">
          {/* PHASE-11 START */}
          <Image
            src="/icons/icon-512x512.png"
            alt="MiComms Logo"
            width={64}
            height={64}
            className="mx-auto"
            placeholder="blur"
            blurDataURL={getImagePlaceholder(64, 64)}
          />
          {/* PHASE-11 END */}
        </div>
        <h1 className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">MiComms</h1>
        <p>Preparing your PR workspace...</p>
        <div className="loading-glass-container">
          <div className="loading liquid-glass-spinner"></div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
